import React from "react";

export interface RouteDef {
  component: React.ComponentType<any>;
  path: string;
  titleKey: string;
  permission: (typeof permissionsList)[keyof typeof permissionsList][];
}

export const permissionsList = {
  /*
  platformClientRegister: "platformClientRegister",
  platformClientRegisterDetail: "platformClientRegisterDetail",
  platformList: "platformList",
  platformCreate: "platformCreate",
  platformDetail: "platformDetail",
  platformEdit: "platformEdit",
  platformPayment: "platformPayment",
  platformPaymentDetail: "platformPaymentDetail",
  platformRenew: "platformRenew",
  platformShow: "platformShow",
  platformUser: "platformUser",
  platformUserDetail: "platformUserDetail",
  */

  // login
  userIsLogin: "userIsLogin",

  // home
  homeOverview: "homeOverview",
  homeMessage: "homeMessage",
  // myShop
  // ---Customer
  myShopCustomerList: "myShopCustomerList",
  myShopCustomerCreate: "myShopCustomerCreate",
  myShopCustomerCreateBulk: "myShopCustomerCreateBulk",
  myShopCustomerEdit: "myShopCustomerEdit",
  // ---Invoice
  myShopInvoiceList: "myShopInvoiceList",
  myShopInvoiceCallback: "myShopInvoiceCallback",
  myShopInvoiceCorrection: "myShopInvoiceCorrection",
  myShopInvoiceCreate: "myShopInvoiceCreate",
  myShopInvoiceEdit: "myShopInvoiceEdit",
  // ---Product
  myShopProductList: "myShopProductList",
  myShopProductCreate: "myShopProductCreate",
  myShopProductCreateBulk: "myShopProductCreateBulk",
  myShopProductEdit: "myShopProductEdit",
  // ---Coupon
  myShopCouponList: "myShopCouponList",
  myShopCouponCreate: "myShopCouponCreate",
  myShopCouponEdit: "myShopCouponEdit",

  // mySale
  mySaleReport: "mySaleReport",
  mySaleBalanceAndWithdraw: "mySaleBalanceAndWithdraw",
  mySaleRequestWithdraw: "mySaleRequestWithdraw",
  mySaleShowAllTransactionDetails: "mySaleShowAllTransactionDetails",

  // Connections
  connection: "connection",
  connectionIpgToken: "connectionIpgToken",
  connectionIpgDocument: "connectionIpgDocument",
  connectionIpgOauth: "connectionIpgOauth",
  connectionIpgServicesIpgServiceDetail: "connectionIpgServicesIpgServiceDetail",
  connectionIpgServicesCategoryIpgServicesCategory: "connectionIpgServicesCategoryIpgServicesCategory",

  // Profile
  profileUserProfile: "profileUserProfile",
  profileProfileDetail: "profileProfileDetail",
  profileUserPassword: "profileUserPassword",
  profileUserTwoFA: "profileUserTwoFA",
  profileUserMessaging: "profileUserMessaging",
  profileDisplaySettings: "profileDisplaySettings",
  profileUserClientsList: "profileUserClientsList",
  profileUserSocial: "profileUserSocial",

  // Settings
  settingsList: "settingsList",
  settingsPersonalList: "settingsPersonalList",
  settingsPersonalEdit: "settingsPersonalEdit",
  settingsPersonalEditMobile: "settingsPersonalEditMobile",
  settingsBankList: "settingsBankList",
  settingsBankEdit: "settingsBankEdit",
  settingsBankEditMobile: "settingsBankEditMobile",
  userProfileSocial: "userProfileSocial",
  settingsBusinessList: "settingsBusinessList",
  settingsBusinessEdit: "settingsBusinessEdit",
  settingsBusinessEditMobile: "settingsBusinessEditMobile",
  settingsTerminalListAndEdit: "settingsTerminalListAndEdit",

  // User
  userRoot: "userRoot",
  userUpgrade: "userUpgrade",
  userReferral: "userReferral",
  userOtherUserRoutes: "userOtherUserRoutes",

  // register
  registerRoot: "registerRoot",
  registerPersonal: "registerPersonal",
  registerBusinessCreate: "registerBusiness",
  registerBankCreate: "registerBank",

  // settlement
  settlementOverview: "settlementOverview",
  settlementCreate: "settlementCreate",
  settlementList: "settlementList",
  settlementTransactionList: "settlementTransactionList",
  settlementRecordList: "settlementRecordList",
  settlementID: "settlementID",
  settlementIDCreate: "settlementIDCreate",

  // digitalAccount
  digitalAccountRoot: "digitalAccountRoot",
} as const;

export const userLoginPermissions = {
  userIsLogin: "userIsLogin",

  // home
  homeOverview: "homeOverview",
  homeMessage: "homeMessage",
  // myShop
  // ---Customer
  myShopCustomerList: "myShopCustomerList",
  myShopCustomerCreate: "myShopCustomerCreate",
  myShopCustomerCreateBulk: "myShopCustomerCreateBulk",
  myShopCustomerEdit: "myShopCustomerEdit",
  // ---Invoice
  myShopInvoiceList: "myShopInvoiceList",
  myShopInvoiceCallback: "myShopInvoiceCallback",
  myShopInvoiceCorrection: "myShopInvoiceCorrection",
  myShopInvoiceCreate: "myShopInvoiceCreate",
  myShopInvoiceEdit: "myShopInvoiceEdit",
  // ---Product
  myShopProductList: "myShopProductList",
  myShopProductCreate: "myShopProductCreate",
  myShopProductCreateBulk: "myShopProductCreateBulk",
  myShopProductEdit: "myShopProductEdit",
  // ---Coupon
  myShopCouponList: "myShopCouponList",
  myShopCouponCreate: "myShopCouponCreate",
  myShopCouponEdit: "myShopCouponEdit",

  // mySale
  mySaleReport: "mySaleReport",
  mySaleBalanceAndWithdraw: "mySaleBalanceAndWithdraw",
  mySaleRequestWithdraw: "mySaleRequestWithdraw",
  mySaleShowAllTransactionDetails: "mySaleShowAllTransactionDetails",

  // Connections
  connection: "connection",
  connectionIpgToken: "connectionIpgToken",
  connectionIpgDocument: "connectionIpgDocument",
  connectionIpgOauth: "connectionIpgOauth",
  connectionIpgServicesIpgServiceDetail: "connectionIpgServicesIpgServiceDetail",
  connectionIpgServicesCategoryIpgServicesCategory: "connectionIpgServicesCategoryIpgServicesCategory",

  // Profile
  profileUserProfile: "profileUserProfile",
  profileProfileDetail: "profileProfileDetail",
  profileUserPassword: "profileUserPassword",
  profileUserTwoFA: "profileUserTwoFA",
  profileUserMessaging: "profileUserMessaging",
  profileDisplaySettings: "profileDisplaySettings",
  profileUserClientsList: "profileUserClientsList",
  profileUserSocial: "profileUserSocial",

  // Settings
  settingsList: "settingsList",
  settingsPersonalList: "settingsPersonalList",
  settingsPersonalEdit: "settingsPersonalEdit",
  settingsPersonalEditMobile: "settingsPersonalEditMobile",
  settingsBankList: "settingsBankList",
  settingsBankEdit: "settingsBankEdit",
  settingsBankEditMobile: "settingsBankEditMobile",
  userProfileSocial: "userProfileSocial",
  settingsBusinessList: "settingsBusinessList",
  settingsBusinessEdit: "settingsBusinessEdit",
  settingsBusinessEditMobile: "settingsBusinessEditMobile",
  settingsTerminalListAndEdit: "settingsTerminalListAndEdit",

  // User
  userRoot: "userRoot",
  userUpgrade: "userUpgrade",
  userReferral: "userReferral",
  userOtherUserRoutes: "userOtherUserRoutes",

  // register
  registerRoot: "registerRoot",
  registerPersonal: "registerPersonal",
  registerBusinessCreate: "registerBusiness",
  registerBankCreate: "registerBank",
} as const;

export type RoutesConstType<Names extends string = string> = Record<Names, RouteDef>;
